import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
    MainBlockContainer,
    MainBlockTitle,
    MainBlockWrapper,
    MainBlockSubtitle,
    MainBlockButton,
} from '../../../for-businesses/components/constructor/styled';
import { useNavigate } from 'react-router-dom';
import { CSSObject } from 'styled-components';
import { handleDownloadClick } from 'utils';

interface MainBlockProps {
    config: {
        title: string;
        subtitle?: string;
        imagePath?: string;
        link: string;
        imageStyles: CSSObject;
        withoutGradient?: boolean;
        buttonLabel?: string;
        downloadLink?: {
            fileName: string;
        };
        blank?: boolean;
        onDownload?: () => void;
    };
}

export const MainBlock: FC<MainBlockProps> = ({
    config: {
        title,
        subtitle,
        imagePath,
        imageStyles,
        link,
        withoutGradient,
        buttonLabel,
        downloadLink,
        blank,
        onDownload,
    },
}) => {
    const { t } = useTranslation('pages/for-businesses');
    const navigate = useNavigate();

    return (
        <MainBlockContainer
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                if (onDownload) {
                    onDownload();
                }

                if (downloadLink) {
                    return handleDownloadClick(e, downloadLink.fileName, link);
                }
            }}
            to={link}
            target={blank ? '_blank' : '_self'}
            withoutGradient={withoutGradient}
            imagePath={imagePath}
            imageStyles={imageStyles}>
            <MainBlockWrapper>
                <MainBlockTitle>{title}</MainBlockTitle>
                {subtitle && <MainBlockSubtitle>{subtitle}</MainBlockSubtitle>}
                <MainBlockButton
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        if (onDownload) {
                            onDownload();
                        }

                        if (downloadLink) {
                            return handleDownloadClick(
                                e,
                                downloadLink.fileName,
                                link
                            );
                        }

                        return blank
                            ? window.open(link, '_blank')
                            : navigate(link);
                    }}
                    variant={'outlined'}
                    color={!withoutGradient ? 'secondary' : 'primary-contrast'}
                    size={'large'}>
                    {buttonLabel ? buttonLabel : t('all-courses')}
                </MainBlockButton>
            </MainBlockWrapper>
        </MainBlockContainer>
    );
};
